import { Instagram, MapPin, MessagesSquare, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { INSTAGRAM, LOCATION, NAV_LINKS, PHONE_DISPLAY, PHONE_TEL, WA_DEFAULT } from "../data/site";

export const Footer = () => (
    <footer data-testid="footer" className="relative overflow-hidden bg-navy-deep text-cream">
        <div
            className="pointer-events-none absolute -top-40 right-0 h-96 w-96 rounded-full opacity-20 blur-3xl"
            style={{ background: "radial-gradient(circle, #2A9D8F 0%, transparent 70%)" }}
        />
        <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 md:grid-cols-12 md:px-8 md:py-20">
            <div className="md:col-span-5">
                <div className="flex items-center gap-2.5">
                    <img
                    src="/Images/Logo_Transparent_White.png"
                    alt="Speech Horizon"
                    className="h-20 w-auto object-contain"
                    />
                </div>
                <p className="mt-2 text-xs font-semibold uppercase tracking-[0.25em] text-aqua/70">
                    Speech &amp; Language Therapy
                </p>
                <p className="mt-5 max-w-sm font-jakarta text-2xl font-bold leading-snug text-cream/90">
                    Better Communication. <span className="text-peach">Greater Confidence.</span>
                </p>
            </div>

            <div className="md:col-span-3">
                <h3 className="text-xs font-bold uppercase tracking-[0.25em] text-cream/50">Explore</h3>
                <ul className="mt-5 space-y-3">
                    {NAV_LINKS.map((link) => (
                        <li key={link.path}>
                            <Link
                                to={link.path}
                                data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                                className="text-sm text-cream/70 transition-colors duration-300 hover:text-peach"
                            >
                                {link.label}
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>

            <div className="md:col-span-4">
                <h3 className="text-xs font-bold uppercase tracking-[0.25em] text-cream/50">Get in Touch</h3>
                <ul className="mt-5 space-y-4 text-sm">
                    <li>
                        <a
                            href={PHONE_TEL}
                            data-testid="footer-phone-link"
                            className="flex items-center gap-3 text-cream/80 transition-colors hover:text-peach"
                        >
                            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-white/5 text-aqua">
                                <Phone size={15} />
                            </span>
                            {PHONE_DISPLAY}
                        </a>
                    </li>
                    <li className="flex items-center gap-3 text-cream/80">
                        <span className="flex h-9 w-9 items-center justify-center rounded-full bg-white/5 text-aqua">
                            <MapPin size={15} />
                        </span>
                        {LOCATION}
                    </li>
                    <li className="flex items-center gap-3 text-cream/80">
  <a
    href="https://www.instagram.com/speechhorizon/"
    target="_blank"
    rel="noopener noreferrer"
    className="flex items-center gap-3"
  >
    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-white/5 text-aqua">
      <Instagram size={15} />
    </span>
    {INSTAGRAM}
  </a>
</li>
                </ul>
                <a
                    href={WA_DEFAULT}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-whatsapp-btn"
                    className="mt-7 inline-flex rounded-full bg-peach px-6 py-3 font-jakarta text-sm font-bold text-navy transition-all duration-300 hover:-translate-y-0.5 hover:bg-peach-deep hover:text-cream"
                >
                    Chat on WhatsApp
                </a>
            </div>
        </div>
             <div className="border-t border-white/10">
            <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-6 py-6 text-xs text-cream/50 md:flex-row md:px-8">
                <p data-testid="footer-copyright">© 2026 Speech Horizon. All rights reserved.</p>

                <p className="text-sm text-cream/50">
                    Designed and Managed by{" "}
                    <a
                        href="https://thesocialbee.in/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-yellow-400 transition-colors duration-300 hover:text-yellow-300"
                    >
                        The Social Bee 🐝
                    </a>
                </p>
            </div>
        </div>
    </footer>
);
